import { render, staticRenderFns } from "./AgeRange.vue?vue&type=template&id=023d2f23"
import script from "./AgeRange.vue?vue&type=script&lang=js"
export * from "./AgeRange.vue?vue&type=script&lang=js"
import style0 from "./AgeRange.vue?vue&type=style&index=0&id=023d2f23&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports